// Формирование toolbar
const toolbar = [
  "undo redo",
  "bold italic underline strikethrough",
  "fontselect fontsizeselect formatselect lineheightselect",
  "alignleft aligncenter alignright alignjustify",
  "outdent indent",
  "numlist bullist",
  "forecolor backcolor removeformat",
  "pagebreak",
  "charmap emoticons",
  "fullscreen preview save print",
  "insertfile image media template link anchor codesample",
  "ltr rtl"
].join(" | ");

export default toolbar;
